import { Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import Konva from "konva";

@Component({
  selector: 'konvas',
  standalone: true,
  imports: [],
  template: '',
})
export class KonvasComponent implements OnDestroy, OnChanges {

  private _videoContainer: HTMLVideoElement | undefined;
  private stage!: Konva.Stage;
  private layer!: Konva.Layer;
  private animation: Konva.Animation | undefined;

  constructor(
    private element: ElementRef
  ) {}

  @Input() set videoContainer(value: HTMLVideoElement | undefined) {

    console.log('@Input() set videoContainer', value);

    if(value) {

      this._videoContainer = value;

      this.init();

      this._videoContainer.addEventListener('loadedmetadata', this.onLoadedmetadata.bind(this), false);
      this._videoContainer.addEventListener('canplay', this.onCanplay.bind(this), false);
    }
  }

  public onCanplay(e: any) {
    console.log('canplay', e, e.target, e.target === this._videoContainer);

    if(e.target === this._videoContainer) {
      const pp = this._videoContainer!.play();
      if (pp !== null) {
        pp.then(() => console.log('video feed should be playing ...')).catch((e) => console.error('error', e));
      }
    }

  }

  init(): void {

    console.log('init the stage', this.element.nativeElement.offsetWidth, this.element.nativeElement.offsetHeight);

    this.stage = new Konva.Stage({
      container: this.element.nativeElement,
      width: this.element.nativeElement.offsetWidth,
      height: this.element.nativeElement.offsetHeight
    });

    this.layer = new Konva.Layer();

    this.stage.add(this.layer);

    this.layer.draw();
  }

  public onLoadedmetadata(e: Event) {
    console.log('onLoadedmetadata', e, e.target, e.target === this._videoContainer);

    if(e.target === this._videoContainer) {
      const sourceWidth = this._videoContainer!.videoWidth;
      const sourceHeight = this._videoContainer!.videoHeight;
      const sourceRatio = Math.round((sourceWidth / sourceHeight) * 100) / 100;
      const stageWidth = this.stage.width();
      const stageHeight = this.stage.height();
      const stageRatio = Math.round((this.stage.width() / this.stage.height()) * 100) / 100;

      // console.log('stage', this.stage.width(), this.stage.height(), stageRatio);
      // console.log('source', sourceWidth, sourceHeight, sourceRatio);

      const options = {
        image: this._videoContainer,
        draggable: false,
        x: sourceRatio >= stageRatio ? (((stageHeight * sourceRatio) - stageWidth) / 2) + stageWidth : stageWidth,
        y: sourceRatio < stageRatio ? (((stageWidth / sourceRatio) - stageHeight) / 2) * -1 : 0,
        width: sourceRatio >= stageRatio ? stageHeight * sourceRatio : stageWidth,
        height: sourceRatio < stageRatio ? stageWidth / sourceRatio : stageHeight,
        scale: { x: -1, y: 1 }
      };

      // console.log('options', options);

      const image = new Konva.Image(options);

      // console.log('scaleX', image.scaleX());

      this.layer.add(image);

      this.animation = new Konva.Animation(() => {}, this.layer);
      this.animation.start();
    }
  }

  stopVideo() {
    console.log('stopping video ???');

    this.animation?.stop();

    if(this._videoContainer) {

      console.log('stopping video - removes listeners');
      this._videoContainer.removeEventListener('canplay', this.onCanplay.bind(this), false);
      this._videoContainer.removeEventListener('loadedmetadata', this.onLoadedmetadata.bind(this), false);

      console.log('stopping video - pause video');
      this._videoContainer.pause();

      if (this._videoContainer.srcObject) {
        (this._videoContainer.srcObject as MediaStream).getTracks().forEach((track: MediaStreamTrack) => {
          track.stop();
          console.log('stopping video', track);
        });
      }
      else {
        console.log('stopping video - no srcObject');
      }
      this._videoContainer = undefined;
      delete this._videoContainer;
    }
  }

  takeSnapshot(rotate: number = 0, type: string = 'image/jpeg', quality: number = 0.95, pixelRatio: number = 2): Promise<any> {

    if( ! [0, 90, 180, 270].includes(rotate)) {
      throw new Error('Invalid rotation value: ' + rotate + ' - must be one of 0, 90, 180 or 270');
    }

    const config = { pixelRatio };
    // console.log(config);
    return new Promise(resolve => {

      if(rotate) {

        const tmpCanvas = document.createElement('canvas');
        const canvas = this.stage.toCanvas(config);
        tmpCanvas.width = canvas.width;
        tmpCanvas.height = canvas.height;
        const tmpCtx = tmpCanvas.getContext('2d');
        if (tmpCtx) {
          // console.log('tmpCtx', tmpCtx, rotate, canvas.width, canvas.height);

          if(rotate === 90) {
            tmpCtx.translate(canvas.width, 0); // 90
          }

          if(rotate === 180) {
            tmpCtx.translate(canvas.width, canvas.height); // 180
          }

          if(rotate === 270) {
            tmpCtx.translate(0, canvas.height); // 270
          }

          tmpCtx.rotate(rotate * Math.PI / 180);

          // tmpCtx.translate(canvas.width, 0);
          tmpCtx.drawImage(canvas, 0, 0);
          return tmpCanvas.toBlob(resolve, type, quality);
        }
      }

      return this.stage.toCanvas(config).toBlob(resolve, type, quality);

    });
  }

  ngOnDestroy(): void {
    console.log('Konvas:: ngOnDestroy')
    this.stopVideo();
    if(this.stage) {
      this.stage.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }
}
